import { useState, useEffect } from "react";
import SafeImage from "./SafeImage";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function ImageGallery({ images = [] }) {
  const [i, setI] = useState(0);
  const [zoom, setZoom] = useState(false);
  // Reset to the new product's primary image when the image set changes
  useEffect(() => { setI(0); setZoom(false); }, [images]);
  if (!images.length) return null;
  const src = images[i];

  const next = () => setI((v) => (v + 1) % images.length);
  const prev = () => setI((v) => (v - 1 + images.length) % images.length);

  return (
    <div className="space-y-3">
      <div className="relative aspect-square bg-[color:var(--forest-2)] corner-frame overflow-hidden">
        <SafeImage src={src} alt="" className="w-full h-full object-contain cursor-zoom-in" onClick={() => setZoom(true)} data-testid="gallery-main-image" />
        {images.length > 1 && (
          <>
            <button data-testid="gallery-prev" onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-[rgba(9,18,13,0.7)] p-2 text-gold border border-brass/40 hover:bg-[rgba(9,18,13,0.9)]"><ChevronLeft size={18} /></button>
            <button data-testid="gallery-next" onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 bg-[rgba(9,18,13,0.7)] p-2 text-gold border border-brass/40 hover:bg-[rgba(9,18,13,0.9)]"><ChevronRight size={18} /></button>
          </>
        )}
      </div>
      {images.length > 1 && (
        <div className="grid grid-cols-5 gap-2">
          {images.map((img, idx) => (
            <button key={idx} data-testid={`gallery-thumb-${idx}`} onClick={() => setI(idx)}
              className={`aspect-square overflow-hidden border ${idx === i ? "border-gold" : "border-brass-soft"}`}>
              <SafeImage src={img} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
      {zoom && (
        <div className="fixed inset-0 z-[60] bg-[rgba(9,18,13,0.96)] flex items-center justify-center p-4" onClick={() => setZoom(false)}>
          <button data-testid="zoom-close" onClick={() => setZoom(false)} className="absolute top-4 right-4 text-gold p-2"><X size={26} /></button>
          <SafeImage src={src} alt="" className="max-w-full max-h-full object-contain" />
        </div>
      )}
    </div>
  );
}
